module.exports = __webpack_public_path__ + "static/media/positiveImpactDetailTitle.b2ab1b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/positiveImpactDetailTitle.png
// module id = 900
// module chunks = 0